<!-- Main container with conditional template selection -->
<ng-container *ngTemplateOutlet="isV2 ? v2Template : v1Template"></ng-container>

<!-- V1 Template -->
<ng-template #v1Template>
  <header class="section-header">
    <h3 class="section-title">{{ 'billing.chooseYourPlan' | translate }}</h3>
  </header>

  <mat-radio-group
    class="payment-recurrence-wrapper"
    [value]="payRecurrence" (change)="handlePayRecurrenceChange($event)"
    [(ngModel)]="payRecurrence"
    aria-label="payment recurrence"
  >
    <mat-radio-button
      value="year" color="primary"
      [ngClass]="payRecurrence === 'year' ? 'text-bold' : 'recurrence-option'"
      [trackClick]="{ page: 'Selected Plan Terms', terms: 'Pay Annually' }"
    >
      {{'billing.planOfferAnnually' | translate}}
    </mat-radio-button>
    <mat-radio-button
      value="month" color="primary"
      [ngClass]="payRecurrence === 'month' ? 'text-bold' : 'recurrence-option'"
      [trackClick]="{ page: 'Selected Plan Terms', terms: 'Pay Monthly' }"
    >
      {{'billing.payMonthly' | translate}}
    </mat-radio-button>
  </mat-radio-group>

  <ng-container *ngTemplateOutlet="planCardsTemplate"></ng-container>
</ng-template>

<!-- V2 Template -->
<ng-template #v2Template>
  <div class="v2-container">
    <header class="section-header non-mobile-only">
      <h3 class="section-title">{{
        (useCardEntryExperimentTitle ? 'billing.choosePlanToAddCard' : 'billing.flexiblePricinPlans') | translate
      }}</h3>
    </header>

    <app-payment-recurrence-tabs
      [payRecurrence]="payRecurrence"
      (recurrenceChange)="handleRecurrenceButtonClick($event)"
      (userCountChange)="onUserCountChange($event)"
    ></app-payment-recurrence-tabs>
  </div>

  <ng-container *ngTemplateOutlet="planCardsTemplate"></ng-container>
</ng-template>

<!-- Shared Plan Cards Template -->
<ng-template #planCardsTemplate>
  <div class="plan-cards-wrapper">
    <app-plan-card
      *ngFor="let cardPlan of plans"
      [plan]="cardPlan.plan"
      [currentPlan]="currentPlan"
      [showPopularBadge]="cardPlan.isPopular"
      [useRecommendedBadge]="isStandardDefault"
      [payRecurrence]="payRecurrence"
      [isV2]="isV2"
      [userCount]="userCount"
      [simpleRecurrenceLabel]="isStandardDefault"
      [ngClass]="{ 'v2': isV2 }"
      (planCardBtnClick)="planCardBtnClick.emit($event)"
    ></app-plan-card>
    <app-plan-card
      [ngClass]="{ 'v2': isV2 }"
      [isEnterprisePlan]="true"
      [isV2]="isV2"
      [payRecurrence]="payRecurrence"
      [simpleRecurrenceLabel]="isStandardDefault"
      *ngIf="isV2"
    ></app-plan-card>
  </div>
</ng-template>
